import { IconButton, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";

export default function IconButtonAdd({ onBtnClick, tooltip, size, color, hide }) {
  if (hide) return null;
  return (
    <IconButton onClick={onBtnClick} size={size || "large"} color={color}>
      <Tooltip title={tooltip || ""}>
        <Add fontSize="inherit" />
      </Tooltip>
    </IconButton>
  );
}
